import { RxTemplate } from './rx-template.model';

export const defaultTemplate: RxTemplate = {
	templateId: 'default',
	ui: {
		order: {
			items: {
				sendToChange: { requiresConfirmationForReset: false },
				dueDate: { disabled: false }
			}
		},
		notes: { disabled: false },
		attachments: { disabled: false },
		teethDiagram: {
			items: {
				toothEditorProperties: { hidden: false, disabled: false }
			}
		},
		appliance: {
			items: {
				procedureType: { hidden: false },
				upperLowerCard: { hidden: false }
			}
		},
		implantPlanning: {
			items: {
				procedureType: { hidden: false }
			}
		},
		denture: {
			items: {
				procedureType: { hidden: false },
				stage: { disabled: false },
				mould: { disabled: false },
				shadeSystem: { disabled: false },
				teethShade: { disabled: false },
				gingival: { disabled: false }
			}
		},
		scanOptions: {
			items: {
				procedureType: { hidden: false },
				multiBite: { disabled: false }
			}
		},
		summaryFooter: {
			continueToLabBrokerButton: { hidden: true },
			saveAndContinueLaterButton: { hidden: true }
		},
		modeling: {
			readOnly: false
		}
	},
	behaviors: {
		validation: {
			items: {
				crownSection: { disabled: false },
				scanBody: { disabled: false },
				dentureDetails: { disabled: false }
			}
		}
	}
};
